import { PayloadAction, createSlice } from '@reduxjs/toolkit';

import { IndicatorVariants } from '@formstack/phoenix/components/Indicator/constants';

import { startAppListening } from '@/store/app.listener';

import { TOAST_DEFAULT_DURATION } from './constants';

export type ToastReducerStateType = {
  message: string;
  showToast: boolean;
  variant?: IndicatorVariants;
};

export type ToastActionPayload = {
  message: string;
  variant?: IndicatorVariants;
};

const INITIAL_STATE: ToastReducerStateType = {
  message: '',
  showToast: false,
  variant: IndicatorVariants.success,
};

export const toastSlice = createSlice({
  name: 'fs/toast',
  initialState: INITIAL_STATE,
  reducers: {
    showToast: (state, action: PayloadAction<ToastActionPayload>) => {
      state.message = action.payload.message;
      state.showToast = !!action.payload.message;
      state.variant = action.payload.variant;
    },
    clearToast: (state) => {
      state.showToast = false;
    },
  },
  selectors: {
    toast: (toastState) => toastState,
  },
});

export const { showToast, clearToast } = toastSlice.actions;
export const { toast } = toastSlice.selectors;
export default toastSlice.reducer;

startAppListening({
  actionCreator: showToast,
  effect: async (_, listenerApi) => {
    listenerApi.cancelActiveListeners();
    await listenerApi.delay(TOAST_DEFAULT_DURATION);
    listenerApi.dispatch(clearToast());
  },
});
